var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1599 13.9999C17.3815 13.9999 19.9932 11.3882 19.9932 8.16659C19.9932 4.94492 17.3815 2.33325 14.1599 2.33325C10.9382 2.33325 8.32654 4.94492 8.32654 8.16659C8.32654 11.3882 10.9382 13.9999 14.1599 13.9999Z",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.178 25.6667C24.178 21.1517 19.6863 17.5 14.1563 17.5C8.62631 17.5 4.13464 21.1517 4.13464 25.6667",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.88a21936.svg";
export { ForwardRef as ReactComponent };